export default  {
  bindings: {
    offer: '='
  },
  controller: 'offerFormController',
  template: require('../views/offer.form.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/offer/components/offer.form.component.js